export const getContent = (tilesContent, type) => {
  // Real array (also small) so do not have to optimize
  const keys = Object.keys(tilesContent);
  for (let i = 0; i < keys.length; i++) {
    if (keys[i] === type) {
      return tilesContent[keys[i]];
    }
    if (tilesContent[keys[i]].subTiles) {
      const tile = getContent(tilesContent[keys[i]].subTiles || [], type);
      if (tile) {
        return tile;
      }
    }
  }
  return null;
};

export const getTile = (tiles, type) => {
  // Real array (also small) so do not have to optimize
  for (let i = 0; i < tiles.length; i++) {
    if (tiles[i].type === type) {
      return tiles[i];
    }
    if (tiles[i].subTiles) {
      const tile = getTile(tiles[i].subTiles || [], type);
      if (tile) {
        return tile;
      }
    }
  }
  return null;
};

export const getTileCMSData = (tileData, type) => {
  for (const tile in tileData) {
    if (tile === type) {
      return tileData[tile];
    } else {
      const subTiles = tileData[tile].subTiles;
      if (subTiles) {
        const data = getTileCMSData(tileData[tile].subTiles, type);
        if (data) {
          return data;
        }
      }
    }
  }
  return null;
};
